/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const GET_ALL_USER_GROUPS = 'GET_ALL_USER_GROUPS';
export const SET_SELECTED_USER_GROUP = 'SET_SELECTED_USER_GROUP';
export const SET_SEARCH_VALUE_OF_USER_GROUP = 'SET_SEARCH_VALUE_OF_USER_GROUP';
export const FETCH_USERS_BY_GROUP_REQUEST = 'FETCH_USERS_BY_GROUP_REQUEST';
export const FETCH_USERS_BY_GROUP_SUCCESS = 'FETCH_USERS_BY_GROUP_SUCCESS';
export const FETCH_USERS_BY_GROUP_FAILURE = 'FETCH_USERS_BY_GROUP_FAILURE';